import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
// import girl from "../../assets/girl.webp";
import ReactImageZoom from "react-image-zoom";
import Cards from "./Cards";
import "../ProductDetailscompnt/productdetail.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import store from "../../redux/Store";
import Trending from "../pages/homeComponents/Trending";

import EncryptDecrypt from "../../common/Crypto";
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Rating, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DefImg from "../../assets/avatar.png";
import { ConstructionOutlined } from "@mui/icons-material";
import { data } from "jquery";


const Productdetail = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  let { state } = useLocation();
  let { p_detail } = state;
  const [p_details, setPdetails] = useState(p_detail);
  const [karat, setKarat] = useState(p_details.varient[0].karat);
  const [size, setSize] = useState(p_details.varient[0].id);
  const [productCode, setProductCode] = useState(p_details.varient[0].product_code);
  const [huid, setHuid] = useState(p_details.varient[0].HUID);
  const [settings, setSettings] = useState('');



  const [p_weight, setWeight] = useState(p_details.varient[0].weight);
  const [allVarData, setAllVarData] = useState([]);
  const [availableKarat, setAvailableKarat] = useState([]);
  const [varientdata, setvarientdata] = useState("");
  const [alreadyinCart, setalreadyinCart] = useState(false);
  const [favIcon, setfavIcon] = useState(0);
      const user = useSelector((state) => state.auth.user);

  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  const [collectionData, setCollectionData] = useState([]);
  const RdxCart = useSelector((state) => state.cart);

  const [selectedImg, setSelectedImg] = useState(p_details.product_image[0].id);

  const [mainImg, setMainImage] = useState(p_details.product_image[0].url);

  const navigate = useNavigate();
  const [HomeData, setHomeData] = useState([]);
  const favCount = useSelector((state) => state.favCount);

  const[reviews,setReviews]=useState([]);
  useEffect(() => {
    setPdetails(p_detail);
    setMainImage(p_detail.product_image[0].url);
    setfavIcon(p_detail.fav_status);
  }, [p_detail]);

  useEffect(() => {
    ApiCall("appsetting").then((data) => {
      if (data.message === "Success") {
        setSettings(data.result);
      }
    });
  }, []);

  console.log(p_details,'che');
  const homeSection = () => {
    const params =
      user && user.id > 0
        ? { customer_id: user.id }
        : cusId && cusId > 0
        ? { customer_id: cusId }
        : {};
    // console.log("Params -->>", params);

    ApiCall("homeSection", params)
      .then((data) => {
        console.log("Home", data);
        if (data.message == "Success") {
          setHomeData(data.result[5].data);
        }
      })
      .catch((err) => console.log(err));
  };

  // console.log(HomeData);

  useEffect(()=>{
    homeSection();
  },[])
  // console.log(allVarData);
  useEffect(() => {
    const collectionParams = {
      branch_type: "collection",
      branch_id: p_details.collect_id,
      customer_id: cusId,
      // page_number: 0,
    };
    ApiCall("webFindClick", collectionParams).then((data) => {
      // console.log(data, "fwrwtyig");
      setCollectionData(data);
    });
  }, [p_details]);

  useEffect(() => {
    isInCart();
  }, [RdxCart, varientdata, p_details]);

  {
    /**check if cart is already set or not */
  }
  const isInCart = () => {

    const currentSize = p_details.varient[0].id;

    setSize(currentSize);
    if (varientdata == "") {
      let cartarr = Object.values(RdxCart).filter((val) => {
        // console.log(val.product_id);
        if (
          val.product_id == p_details.product_id &&
          val.order_sizes == p_details.varient[0].size &&
          val.karat == p_details.varient[0].karat
        ) {
          return true;
        } else {
          return false;
        }
      });
      console.log(cartarr);

      cartarr.length == 1 ? setalreadyinCart(true) : setalreadyinCart(false);
      // console.log(cartarr.length,'1tttttttttttttttttttttt');
    } else {
      let cartarr = Object.values(RdxCart).filter((val) => {
        if (
          val.product_id == p_details.product_id &&
          val.order_sizes == varientdata.size &&
          val.karat == varientdata.karat
        ) {
          return true;
        } else {
          return false;
        }
      });
      cartarr.length == 1 ? setalreadyinCart(true) : setalreadyinCart(false);
      // console.log(cartarr.length,'sssssssssssssssssssss');
    }
  };
  useEffect(() => {
    setData();
  }, [p_details]);

  async function setData() {
    let karatsAvail = [];
    p_details.varient.forEach((val) => {
      karatsAvail.push(val.karat);
    });
    karatsAvail = [...new Set(karatsAvail)];
    setAvailableKarat(karatsAvail);
    setKarat(karatsAvail[0]);

    let allVarientData = [];
    karatsAvail.forEach((val) => {
      let karatData = [];
      p_details.varient.forEach((value) => {
        if (val === value.karat) {
          karatData.push(value);
        }
      });
      allVarientData.push({ value: val, data: karatData });
    });
    setAllVarData(allVarientData);
  }

  const handleSizeChange = (data) => {

    console.log(data,'datas');
    setTimeout(async () => {
      await setSize(data.id);

    },100)
    setvarientdata(data);
  };

  async function additemtoCart() {
    if (varientdata == "") {
      store.dispatch({
        type: "addToCart",
        payload: {
          product_id: p_details.product_id,
          product_name: p_details.product_name,
          product_image: p_details.product_image,
          order_sizes: p_details.varient[0].size,
          karat: p_details.varient[0].karat,
          weight: p_details.varient[0].weight,
          order_price: p_details.varient[0].offer_price,
          varient: p_details.varient[0].varient,
          variant_id: p_details.varient[0].id,
          packing_charges: p_details.packing_charges,
        },
      });
    } else {
      store.dispatch({
        type: "addToCart",
        payload: {
          product_id: p_details.product_id,
          product_name: p_details.product_name,
          product_image: p_details.product_image,
          order_sizes: varientdata.size,
          karat: varientdata.karat,
          weight: varientdata.weight,
          order_price: varientdata.offer_price,
          varient: p_details.varient[0].varient,
          variant_id: varientdata.id,
          packing_charges: p_details.packing_charges,
        },
      });
    }
  }
  
  // console.log(allVarData);
  const additemToFav = (fav) => {
    {
      /**add fav */
    }
    console.log(fav);
    const favParams = { customer_id: cusId, product_id: p_details.product_id };
    console.log(favParams);
    if (favIcon == 0) {
      // console.log("323454");
      ApiCall("addFav", favParams)
        .then((data) => {
          console.log(data);
          if (data.message == "Success") {
            store.dispatch({type: 'addfavCount', payload: favCount.qty + 1})
            // console.log(data);

            setfavIcon(1);
            // toast.success("Favourite added", {
            //   position: "top-right",
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "colored",
            // });
          } else {
          }
        })
        .catch((err) => console.log(err));
    } else {
      // console.log("232");
      ApiCall("removeFav", favParams)
        .then((data) => {
          // console.log(data);
          if (data.message == "Success") {
            store.dispatch({type: 'addfavCount', payload: favCount.qty - 1})
            console.log(" removed");
            setfavIcon(0);
            // toast.success("Favourite Removed", {
            //   position: "top-right",
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "colored",
            // });
          } else {
          }
        })
        .catch((err) => console.log(err));
    }
  };
  // console.log(allVarData);

  // const imag = [
  //   {
  //     id: "1",
  //     image: girl,
  //   },
  //   {
  //     id: "2",
  //     image: girl,
  //   },
  //   {
  //     id: "3",
  //     image: girl,
  //   },
  //   {
  //     id: "4",
  //     image: girl,
  //   },
  //   {
  //     id: "5",
  //     image: girl,
  //   },
  // ];
  // console.log(p_details);

  useEffect(() => {
    p_details.product_image.map((data) => {
      if (data.id == selectedImg) {
        setMainImage(data.url);
      }
    });
  }, [selectedImg]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const props = {
    // width: windowSize != null && windowSize >= 500 ? 300 : 180,
    width:
      windowSize != null && windowSize >= 1440
        ? 300
        : windowSize >= 1366
        ? 250
        : windowSize >= 1024
        ? 210
        : windowSize >= 768
        ? 330
        : windowSize >= 540
        ? 300
        : windowSize >= 410
        ? 230
        : windowSize >= 360
        ? 180
        : windowSize >= 280
        ? 150
        : 150,

    zoomWidth: 500,
    zoomStyle:{display:"none"},
    img: Web_url.Domain_url + mainImg,
    zoomPosition:
      windowSize != null && windowSize >= 1440
        ? ""
        : windowSize >= 1366
        ? ""
        : windowSize >= 1024
        ? ""
        : windowSize >= 768
        ? "bottom"
        : windowSize >= 540
        ? "bottom"
        : windowSize >= 410
        ? "bottom"
        : windowSize >= 360
        ? "bottom"
        : windowSize >= 280
        ? "bottom"
        : "bottom",
  };
  // console.log(p_details.product_description.slice(0,150));
  // console.log(karat);
  const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
      setIsReadMore(!isReadMore);
    };
    return (
      <p className="text">
        {isReadMore ? text.slice(0, 130) : text}
        <span
          onClick={toggleReadMore}
          className="read-or-hide"
          style={{ color: "#126a38" ,cursor:"pointer" }}
        >
          {isReadMore ? "...read more" : " show less"}
        </span>
      </p>
    );
  };
    const ReadMores = ({ children }) => {
      const text = children;
      const [isReadMore, setIsReadMore] = useState(true);
      const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
      };
      return (
        <p className="text">
          {isReadMore ? p_details.product_description.slice(0, 100) : text}
          <span
            onClick={toggleReadMore}
            className="read-or-hide"
            style={{ color: "#126a38",cursor:"pointer" }}
          >
            {isReadMore ? "...read more" : " show less"}
          </span>
        </p>
      );
    };
  // console.log(HomeData);

  useEffect(()=>{

    const reviewParams = { product_id: p_details.product_id };

    ApiCall("reviews",reviewParams).then((data)=>{
     setReviews(data.result);
    });
  },[])

const handlekaratchange = async(val,datas,index)=>{

  console.log(datas,'123456',index);

  setKarat(val);
  var newSize;
  var newCT ;
  var huid;
  var product_code;
  datas.forEach(v  => {
   if(v.value  == val){
      newSize = v.data[0].id
      newCT = v.data[0]
      huid = v.data[0].HUID
      product_code = v.data[0].product_code
    } 
  })
  setTimeout(() => {
  
    setSize(newSize);
    setHuid(huid);
    setProductCode(product_code);  
  }, 100);
  // console.log(newCt,"nect");
  setvarientdata(newCT);
    


}  

  // console.log(reviews[0].customer_name);
  return (
    <>
      <Header make={true} />
      <div
        className="product_details  d-flex flex-column  gap-4 container-fluid"
        style={{ backgroundColor: Colors.bg_color, paddingTop: "50px" }}
      >
        <div className="top row justify-content-center">
          {/* <span className="product_heading">{p_details.product_name}</span> */}
          <div className="d-flex justify-content-between align-items-center backandtitle">
            <span className="product_heading">{p_details.product_name}</span>
            {/* <div className="back_button">
              <a
                href="javascript:history.go(-1)"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="btn btn-basic p-0"
                  style={{
                    background: Colors.Base_color,
                    color: "white",
                    width: "",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <i class="fa-solid fa-caret-left"></i>
                  <span
                    style={{ position: "relative", left: "6px", top: "0px" }}
                  >
                    Back
                  </span>
                </button>
              </a>
            </div> */}
            <div className="back_button">
              <a
                href="javascript:history.go(-1)"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: "white",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mx-2">
                    <i
                      class="fa-solid fa-caret-left"
                      style={{ fontSize: "18px" }}
                    ></i>
                    <span style={{ paddingTop: "1px" }}>Back</span>
                  </div>
                </button>
              </a>
            </div>
          </div>

          <div className="col-xxl-4  col-xl-4 col-lg-5 col-md-10  col-11">
            <div className="row">
              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-3 ">
                <ul
                  className="d-flex flex-column  align-items-center gap-2 "
                  style={{
                    listStyle: "none",
                    marginBottom: "0px",
                    paddingLeft: "0px",
                  }}
                >
                  {p_details.product_image.map((sngleimg, index) => {
                    return (
                      <li
                        className="d-flex justify-content-center p-2"
                        style={{
                          backgroundColor: "white",
                          width: "73px",
                          borderRadius: "15px",
                          border:
                            selectedImg == sngleimg.id
                              ? "1px solid #126a38"
                              : "",
                        }}
                        onClick={() => {
                          setSelectedImg(sngleimg.id);
                        }}
                      >
                        <img
                          src={Web_url.Domain_url + sngleimg.url}
                          width="50"
                          height="50"
                          style={{
                            borderRadius: "5px",
                          }}
                        ></img>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div
                className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-7 ms-3 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "white",
                  paddingLeft: "0px",
                  borderRadius: "15px",
                }}
              >
                <div className=" ">
                  <ReactImageZoom {...props} />
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-6 col-xl-6 col-md-9 col-11"
            id="detail"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              height: "max-content",
            }}
          >
            <div className="details container p-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex flex-row align-items-center gap-2">
                  <span className="offer_p">
                    {" "}
                    ₹
                    {varientdata.offer_price !== undefined
                      ? varientdata.offer_price
                      : p_details.varient[0].offer_price}
                  </span>
                  <span className="orignal_p text-muted">
                    ₹
                    {varientdata.actual_price !== undefined
                      ? varientdata.actual_price
                      : p_details.varient[0].actual_price}
                  </span>
                  <span className="offer_prices">
                    OFF{" "}
                    {varientdata.discount !== undefined
                      ? varientdata.discount
                      : p_details.varient[0].discount}
                    %
                  </span>
                  <div className={windowSize < 575 ? "d-none" : ""}>
                    {p_details.product_Videos.length > 0 ? (
                      <span className="offer_prices">
                        <div
                          className="d-flex align-items-center gap-2 watch_videoo"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate("/product_video", {
                              state: {
                                p_video: p_details,
                              },
                            })
                          }
                        >
                          <span>Watch Video</span>
                          <i class="fa-solid fa-video"></i>
                        </div>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <i
                  class={
                    p_details.fav_status == 1
                      ? "fa-sharp fa-solid fa-heart heartedclr"
                      : "fa-regular fa-heart hearted"
                  }
                  onClick={() => additemToFav(p_details.fav_status)}
                ></i> */}
                {user &&
                  user.id > 0 &&
                  (favIcon == 1 ? (
                    <i
                      class="fa-sharp fa-solid fa-heart heartedclr"
                      onClick={() => additemToFav(p_details.fav_status)}
                      style={{ cursor: "pointer" }}
                    ></i>
                  ) : (
                    <i
                      class="fa-regular fa-heart hearted"
                      style={{ cursor: "pointer" }}
                      onClick={() => additemToFav(p_details.fav_status)}
                    ></i>
                  ))}
              </div>
              <Rating
                style={{ fontSize: "25px" }}
                id="rating"
                name="no-value"
                value={p_details.over_all_ratings}
                readOnly
              />
              <div className={windowSize < 575 ? "" : "d-none"}>
                {p_details.product_Videos.length > 0 ? (
                  <span className="offer_prices">
                    <button
                      className="d-flex align-items-center gap-2 watch_videoo"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/product_video", {
                          state: {
                            p_video: p_details,
                          },
                        })
                      }
                    >
                      <span>Watch Video</span>
                      <i class="fa-solid fa-video"></i>
                    </button>
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="d-flex flex-column ">
                {/* <div className="d-flex align-items-center ">
                  <span className="text-muted from">from:</span>
                  <span className="coll_name">{p_details.collection_name}</span>
                </div> */}
                <div className="d-flex align-items-center">
                  <span className="text-muted from">Variant:</span>
                  <span className="coll_name">
                    {varientdata.varient !== undefined
                      ? varientdata.varient
                      : p_details.varient[0].varient}
                  </span>
                </div>
              </div>
              <div
                className="d-flex flex-column gap-2 "
                style={{ width: "85%" }}
              >
                <span className="product_heading2">
                  {" "}
                  {p_details.product_name}
                </span>

                <span
                  style={{ wordWrap: "break-word" }}
                  className="descriptions"
                >
                  <ReadMore>{p_details.short_description}</ReadMore>
                </span>
              </div>
              {/* <div className="karat d-flex flex-column mt-4">
                <span>Choose Product</span>
                <div className="d-flex gap-3 mt-4">
                  {availableKarat.map((val, index) => {
                    return (
                      <button
                        type="button "
                        id="karat-buttons"
                        className="btn btn-lg"
                        style={{
                          backgroundColor: karat.includes(val) ? "#126a38" : "",
                          color: karat.includes(val) ? "white" : "black",
                        }}
                        onClick={() =>
                          handlekaratchange(val, allVarData, index)
                        }
                      >
                        {val} CT
                      </button>
                    );
                  })}
                </div>
              </div> */}
              <div className="size mt-4">
              <span>Choose Product</span>
                <div className="d-flex mt-4 gap-2">
                  {allVarData.map((val) => {
                    {
                       console.log(val,"karatkaratkarat");
                    }
                    return (
                      val.value === karat &&
                      val.data.map((value, index) => {
                        console.log(value, "l;l;l", size);
                        return (
                          <button
                            type="button "
                            id="inch-buttons"
                            className="btn btn-lg"
                            style={{
                              backgroundColor:
                                size == value.id ? "#126a38" : "",
                              color: size != value.id  ? "#126a38" : "white",
                              borderColor: '#126a38'
                            }}
                            onClick={() => handleSizeChange(value)}
                          >
                            {value.varient} 
                          </button>
                        );
                      })
                    );
                  })}
                </div>
              </div>
              {/* <div className="karat d-flex flex-column mt-4">
                <span>Weight</span>
                <div className="d-flex gap-3 mt-4">=
                  <button
                    type="button "
                    id="karat-buttons"
                    className="btn btn-lg"
                    style={{
                      backgroundColor: "#126a38",
                      color: "white",
                    }}
                    // onClick={() => setWeight(val[0].data.wei)}
                  >
                    {varientdata.weight !== undefined
                      ? varientdata.weight
                      : p_detail?.varient[0].weight}
                    g
                  </button>
                </div>
              </div> */}
              <div
                className="d-flex flex-column gap-2 mt-4 mb-3"
                style={{ width: "85%" }}
              >
                <span className="about_product">About the product</span>
                <span
                  style={{ wordWrap: "break-word" }}
                  className="descriptions"
                >
                  <ReadMores> {p_details.product_description}</ReadMores>
                </span>
              </div>
              {/* <div className="d-flex flex-column">
                <span className="about_product">Product details</span>
                <div className="p_id_dimenstion d-flex flex-column gap-1 mt-3">
                <span>Product Code: {productCode}</span>
                  <span>HUID: {huid}</span>
                  <span>
                    Dimensions:{" "}
                    <small style={{ fontFamily: "AvenirLTStdMedium" }}>
                      Length-{p_details.dimensions_length} mm,Width-
                      {p_details.dimensions_width} mm
                    </small>
                  </span>
                  <span>
                     {p_detail.return_status===1? "Return Available":"Return Not Available"}
                     {
                        p_detail.return_status===1?
                     <i
                      class="fa-solid fa-circle-check"
                      style={{ color: "green", paddingLeft: "3px" }}
                    ></i>: <i
                    class="fa-solid fa-times-circle"
                    style={{ color: "red", paddingLeft: "3px" }}
                  ></i>
                  }

                  </span>
                </div>
              </div> */}
              <div className="d-flex flex-column mt-4">
                <span className="about_product">Our policies includes</span>
                <div className="d-flex gap-3 mt-3 policy-list">
                  <div role={"button"} data-bs-toggle="modal" data-bs-target="#returnPolicyModal">
                <img src={images.returnPolicy} className="mb-1"  style={{ width: "60px" ,backgroundColor:"#126a38",padding:"5px",borderRadius:"10px"}} alt="return-policy"></img><br></br>Return<br></br>Policy
                </div>
                <div role={"button"} data-bs-toggle="modal" data-bs-target="#lifeExchangeModal">
                <img src={images.lifeExchange} className="mb-1" style={{ width: "60px",backgroundColor:"#126a38",padding:"5px",borderRadius:"10px" }} alt="life-exchange"></img><br></br>Lifetime<br></br>Exchange
                </div>
                <div role={"button"} data-bs-toggle="modal" data-bs-target="#freeDeliveryModal">
                <img src={images.delivery} className="mb-1" style={{ width: "60px",backgroundColor:"#126a38",padding:"5px",borderRadius:"10px" }} alt="free-delivery"></img><br></br>Free Door<br></br>Delivery
                </div>

                {/* <span>Product Code: {productCode}</span>
                  <span>HUID: {huid}</span>
                  <span>
                    Dimensions:{" "}
                    <small style={{ fontFamily: "AvenirLTStdMedium" }}>
                      Length-{p_details.dimensions_length} mm,Width-
                      {p_details.dimensions_width} mm
                    </small>
                  </span> */}
                </div>
              </div>
              <div className="d-flex flex-column mt-3">
                <span className="mt-3 about_product">Certified By</span>
                <img src={images.certi} style={{ width: "80px" }}></img>
              </div>
              <div className="d-flex flex-column mt-3">
                <span className="about_product">Delivery Options</span>
                <div className="d-flex flex-column mt-2">
                  <span>
                    Standard Delivery{" "}
                    <i
                      class="fa-solid fa-circle-check"
                      style={{ color: "green", paddingLeft: "3px" }}
                    ></i>
                  </span>
                  <span>
                    Cash on Delivery(COD){" "}
                    <i
                      class="fa-solid fa-circle-check"
                      style={{ color: "green", paddingLeft: "3px" }}
                    ></i>
                  </span>
                </div>
              </div>
              <div className="each_product_reviews">
                <Accordion className="d-flex  flex-column ">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="accordion_sum"
                  >
                    <Typography
                      style={{ color: "#126a38" }}
                      className="title_of_review"
                    >
                      Customer Review
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {reviews && reviews != ""
                      ? reviews.slice(0, 3).map((datas) => {
                          return (
                            <div className="d-flex flex-row align-items-center gap-4 pb-4">
                              <Avatar
                                alt={datas ? datas.customer_name : ""}
                                src={
                                  datas.avatar != ""
                                    ? Web_url.Domain_url + datas.avatar
                                    : DefImg
                                }
                                sx={{ width: 56, height: 56 }}
                              />
                              <div className="d-flex flex-column">
                                <span>
                                  {datas.customer_name
                                    .replace(/\s{2,}/g, " ")
                                    .trim() != ""
                                    ? datas.customer_name
                                    : "Unknown"}
                                </span>
                                <Rating
                                  style={{ fontSize: "20px" }}
                                  id="rating"
                                  name="no-value"
                                  value={datas.cus_rating}
                                  readOnly
                                />
                                <span className="single_product_feedbacks">
                                  {datas.cus_feed}
                                </span>
                              </div>
                            </div>
                          );
                        })
                      : "No Reviews"}
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="d-flex justify-content-center mt-5 mb-5">
                {alreadyinCart === false ? (
                  <button
                    type="button"
                    id="addbag"
                    className="btn btn-lg"
                    style={{
                      fontSize: "1.3rem",
                      fontFamily: "AvenirLTStdMedium",
                    }}
                    onClick={() => additemtoCart()}
                  >
                    Add to bag
                  </button>
                ) : (
                  <button
                    type="button"
                    id="addbag"
                    className="btn btn-lg"
                    style={{
                      fontSize: "1.3rem",
                      fontFamily: "AvenirLTStdMedium",
                    }}
                    onClick={() => {
                      navigate("/mycart");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    View Cart
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div>
          {/* {collectionData.length != 0 ? (
            <Cards collections={collectionData} cusId={cusId} />
          ) : (
            <span className="d-flex justify-content-center pt-5 pb-5">
              No Data
            </span>
          )} */}
          <Trending
            windowSize={windowSize}
            trendingData={HomeData.length > 0 ? HomeData : null}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ paddingLeft: "10%", paddingRight: "10%" }}
        >
          <div className="d-flex flex-column gap-3">
            <span className="about_product">Theni Kamadhenu Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div>
          {/* <div className="d-flex flex-column gap-3 mt-5">
            <span className="about_product">Jeleso Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div> */}
          <div className="d-flex flex-column gap-3 mt-5 mb-5">
            <span className="about_product">Theni Kamadhenu Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div>
        </div>
      </div>
      <div class="modal fade" id="returnPolicyModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"   aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle" style={{color:"#126a38"}}>Return Policy</h5>
              <button
                type="button"
                class="btn-close cbutton"
                id="close_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "absolute", right: "10px",top:"10px" }}
              ></button>
            </div>
            <div class="modal-body" style={{color:" #495057"}}>
              {
                settings!=''?<div dangerouslySetInnerHTML={{__html:settings.return_policy.description}}/>:null

              }
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="lifeExchangeModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"   aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle" style={{color:"#126a38"}}>Lifetime Exchange</h5>
              <button
                type="button"
                class="btn-close cbutton"
                id="close_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "absolute", right: "10px",top:"10px" }}
              ></button>
            </div>
            <div class="modal-body" style={{color:" #495057"}}>
              {
                settings!=''?<div dangerouslySetInnerHTML={{__html:settings.life_exchange.description}}/>:null
              }
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="freeDeliveryModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"   aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle" style={{color:"#126a38"}}>Free Door Delivery</h5>
              <button
                type="button"
                class="btn-close cbutton"
                id="close_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "absolute", right: "10px", top:"10px" }}
              ></button>
            </div>
            <div class="modal-body" style={{color:" #495057"}}>
              {
                settings!=''?<div dangerouslySetInnerHTML={{__html:settings.free_delivery.description}}/>:null
              }
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default Productdetail;
